<template>
  <div class="loading_container"><div class="logo">Haven</div></div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.loading_container {
  width: 100%;
  height: 100%;
  display: flex;
  color: #000;
  font-size: 20px;
  align-items: center;
  justify-content: center;

  .logo {
    font-size: 19px;
    font-family: machina2 !important;
  }
}
</style>
